<template>
  <v-container>
    <h1>{{ verb }} Major</h1>
    <v-sheet color="white" elevation="1" class="px-5 mt-4 rounded">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="submit"
      >
        <v-row>
          <v-col>
            <v-text-field
              v-model="form.code"
              :counter="7"
              :disabled="loading"
              :rules="rules.code"
              label="Code"
              required
              validate-on-blur
            />
            <v-text-field
              v-model="form.name"
              :counter="50"
              :disabled="loading"
              :rules="rules.name"
              label="Name"
              required
              validate-on-blur
            />
            <v-select
              v-model="form.group"
              :disabled="loading"
              :items="['SAINTEK', 'SOSHUM']"
              :rules="rules.group"
              label="Group"
              validate-on-blur
            />
            <v-text-field
              v-model="form.score"
              :counter="3"
              :disabled="loading"
              :rules="rules.score"
              type="number"
              label="Score"
              required
              validate-on-blur
            />
            <v-btn
              :disabled="!valid"
              :loading="loading"
              color="success"
              class="mt-2"
              type="submit"
            >
              Submit
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-sheet>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import Major from "@/services/major";

export default {
  name: "Major.Form",
  data() {
    return {
      valid: false,
      form: {
        code: "",
        name: "",
        group: "",
        score: ""
      },
      rules: {
        code: [
          v => !!v || "Code is required",
          v => v.length === 7 || "Code must be 7 digit",
          v => new RegExp(/^[\d]+$/i).test(v) || "Code must be numbers"
        ],
        name: [
          v => !!v || "Name is required",
          v =>
            (v.length >= 5 && v.length <= 50) ||
            "Name must be greater than 5 and less then 50",
          v =>
            new RegExp(/^[\w\-\s]+$/i).test(v) ||
            "Name must only contain alphanumeric and whitespace characters"
        ],
        group: [v => !!v || "Group is required"],
        score: [
          v => !!v || "Score is required",
          v =>
            (parseInt(v) >= 1 && parseInt(v) <= 800) ||
            "Score must be greater than 1 and less than 800"
        ]
      },
      loading: false
    };
  },
  computed: {
    verb() {
      return this.$route.params.id ? "Update" : "Create";
    },
    pastVerb() {
      return `${this.verb}d`;
    },
    dataId() {
      return this.$route.params.id;
    }
  },
  async created() {
    this.setNavbarTitle("Manage Major");
    if (this.dataId) {
      const major = await Major.find(this.dataId);
      const { code, name, group, score } = major.data.data;
      this.form = { code, name, group, score };
    }
  },
  methods: {
    ...mapActions("drawer", ["setNavbarTitle"]),
    async submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          if (this.dataId) {
            await Major.update(this.dataId, this.form);
          } else {
            await Major.create(this.form);
          }

          this.$snackbar.showMessage({
            content: `Data ${this.pastVerb.toLowerCase()}`,
            variant: "success"
          });
          this.$router.push({ name: "Major.Index" });
        } catch (error) {
          this.loading = false;
        }
      }
    }
  }
};
</script>
